import RequestdataAdd from "./RequestdataAdd";
import RequestdataList from "./RequestdataList";
import RequestdataShow from "./RequestdataShow";

export default {
  list: RequestdataList,
  show: RequestdataShow,
  create: RequestdataAdd,
};
